import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import {
    HomePage,
    RegisterPage,
    LoginPage,
    RecoveryPage,
    PageNotFound,
} from "./pages";
import { UCPLayout, AdminLayout, ShopLayout } from "./components/layouts";
import {
    DashboardPage,
    CreateCharacterPage,
    CharacterStatisticsPage,
    RetestCharacterPage,
    SettingsPage,
} from "./pages";
import { ShopMainPage, ShopFavoritesPage, ShopBuyPage } from "./pages";
import { AdminDashboardPage, AdminCharacterPage } from "./pages";
import { useAuthContext } from "./contexts";

function UCP() {
    const { isAuthenticated, loading } = useAuthContext();

    if (loading) return null;
    if (!isAuthenticated) return <Navigate to="/" replace />;

    return (
        <UCPLayout>
            <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route
                    path="/create-character"
                    element={<CreateCharacterPage />}
                />
                <Route
                    path="/statistics"
                    element={<CharacterStatisticsPage />}
                />
                <Route path="/retest" element={<RetestCharacterPage />} />
                <Route path="/settings" element={<SettingsPage />} />
            </Routes>
        </UCPLayout>
    );
}

function ACP() {
    const { isAuthenticated, loading } = useAuthContext();

    if (loading) return null;
    if (!isAuthenticated) return <Navigate to="/" replace />;

    return (
        <AdminLayout>
            <Routes>
                <Route path="/" element={<AdminDashboardPage />} />
                <Route
                    path="/check-characters"
                    element={<AdminDashboardPage />}
                />
                <Route path="/character" element={<AdminCharacterPage />} />
                <Route
                    path="/check-application"
                    element={<AdminCharacterPage />}
                />
            </Routes>
        </AdminLayout>
    );
}

function Shop() {
    const { isAuthenticated, loading } = useAuthContext();

    if (loading) return null;
    if (!isAuthenticated) return <Navigate to="/" replace />;

    return (
        <ShopLayout>
            <Routes>
                <Route path="/" element={<ShopMainPage />} />
                <Route path="/favorites" element={<ShopFavoritesPage />} />
                <Route path="/buy" element={<ShopBuyPage />} />
            </Routes>
        </ShopLayout>
    );
}

function App() {
    const isStaticFile = window.location.pathname.includes(".pdf");

    if (isStaticFile) {
        return null;
    }
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/recovery" element={<RecoveryPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/ucp/*" element={<UCP />} />
                <Route path="/ucp/shop/*" element={<Shop />} />
                <Route path="/acp/*" element={<ACP />} />
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
